"use client";

import { createPreviewIntentStore } from "@/components/feature/preview-intent/preview-intent-store";
import type { PreviewIntentStore } from "@/components/feature/preview-intent/preview-intent-store";
import type { ReactNode } from "react";
import { useRef } from "react";
import { PreviewIntentStoreProvider, usePreviewIntentStoreOptional } from "./PreviewIntentProvider";

/**
 * Ensures a PreviewIntentStore is available.
 * - If an upstream provider exists, it reuses that store.
 * - Otherwise, it creates a local store and provides it.
 */
export function PreviewIntentAutoProvider({ children }: { children: ReactNode }) {
  const existingStore = usePreviewIntentStoreOptional();
  const localStoreRef = useRef<PreviewIntentStore | null>(null);

  if (existingStore) {
    return <>{children}</>;
  }

  if (!localStoreRef.current) {
    localStoreRef.current = createPreviewIntentStore();
  }

  return (
    <PreviewIntentStoreProvider store={localStoreRef.current}>
      {children}
    </PreviewIntentStoreProvider>
  );
}
